import Client from "../AxiosClient";
import fileDownload from "js-file-download";
const resource = "/private/budgetreport";
const resourceFile = "/private/budgetreport/file";
const publicApi = "/public/publicbudgetreport";

export default {
  //#region BudgetReport
  async searchReport(
    reportName,
    circularsTemplateNo,
    circularsNo,
    cateId,
    reportTypeId,
    status,
    periodType,
    periodValue,
    reportYear,
    page,
    size
  ) {
    try {
      if (cateId === -1) cateId = "";
      if (reportTypeId === -1) reportTypeId = "";
      if (status === -1) status = "";
      if (periodType === -1) periodType = "";
      if (periodValue === -1) periodValue = "";
      if (page === -1) page = 1;
      if (size === -1) size = 1000;
      const result = await Client.get(
        `${resource}/searchreport?report_name=${reportName}&circulars_template_no=${circularsTemplateNo}&circulars_no=${circularsNo}&cate_id=${cateId}&report_type_id=${reportTypeId}&status=${status}&period_type=${periodType}&period_value=${periodValue}&report_year=${reportYear}&page=${page}&size=${size}`
      );
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async getById(id) {
    try {
      const result = await Client.get(`${resource}/?id=${id}&page=1&size=1000`);
      return result.data;
    } catch (error) {
      return { error: error };
    }
  },

  async getSummary(status, periodType, periodValue, reportYear) {
    try {
      if (status === -1) status = "";
      if (periodType === -1) periodType = "";
      if (periodValue === -1) periodValue = "";
      if (reportYear === -1) reportYear = "";
      const result = await Client.get(
        `${resource}/getsummary?status=${status}&period_type=${periodType}&period_value=${periodValue}&report_year=${reportYear}`
      );
      return result.data;
    } catch (error) {
      return { error: error };
    }
  },

  async exportSummary(status, periodType, periodValue, reportYear) {
    try {
      if (status === -1) status = "";
      if (periodType === -1) periodType = "";
      if (periodValue === -1) periodValue = "";
      if (reportYear === -1) reportYear = "";

      const params = {
        status: status,
        period_type: periodType,
        period_value: periodValue,
        report_year: reportYear,
      };

      const response = await Client.get(`${resource}/exportsummary`, {
        headers: {
          "Access-Control-Expose-Headers": "Content-Disposition",
        },
        responseType: "blob",
        params: params,
      });
      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async getXml(filter) {
    console.log(filter)
    if (filter.period_type === -1) filter.period_type = "";
    const result = await Client.get(`${publicApi}/exportxml`, {
      params: filter
    });
    fileDownload(result.data, "ckns.xml");
  },

  async insReport(data) {
    try {
      const result = await Client.post(`${resource}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async updReport(data) {
    try {
      const result = await Client.put(`${resource}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async delReport(id) {
    try {
      const result = await Client.delete(`${resource}/${id}`);
      return result;
    } catch (error) {
      return { error: error };
    }
  },
  //#endregion

  //#region BudgetReportFile
  async insFile(data) {
    try {
      const result = await Client.post(`${resourceFile}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },
  async updFile(data) {
    try {
      const result = await Client.put(`${resourceFile}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async getFileByBudgetReportId(id) {
    try {
      const result = await Client.get(
        `${resourceFile}/getByBudgetReportId?budget_report_id=${id}`
      );
      return result.data;
    } catch (error) {
      return { error: error };
    }
  },
  //#endregion
};
